import React from 'react'

 
const DescriptionModal = ({ open, onClose, description }) => {
  return (
    <div className={`modal fade ${open ? "show d-block" : ""}`} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered z-3">
        <div className="modal-content radius-8">
          <div className="modal-header">
            <h5 className="modal-title font-24">Description</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p style={{ whiteSpace: "pre-wrap" }}>{description}</p>
          </div>
        </div>
      </div>
      {open && <div className="modal-backdrop fade show z-0"></div>}
    </div>
  );
};


export default DescriptionModal
